module.exports = __webpack_public_path__ + "img/mishkafaim_no.42cb82d0.png";